<template>
  <tr :class="tableMin ? 'tableMin' : ''">
    <td>
      <div :class="edit ? 'width' : ''">
        <BaseInput
          type="autocomplete"
          v-model="item.work_type_category.id"
          :prepend-inner-icon="tableMin ? 'search' : ''"
          :minimize="!tableMin"
          :items="workTypeCategoryGridAll"
          :readonly="!workTypeCategoryGridAll.length"
          :placeholder="
            localStorage.translations.pages.sales_project['schemes_documents-tables']['ne-vybrano']
          "
          :rules="['required']"
          :view="!edit"
          :view-value="item.work_type_category.name"
        />
      </div>
    </td>
    <td>
      <div :class="edit ? 'width' : ''">
        <BaseInput
          type="autocomplete"
          :readonly="
            (!item.work_type_category.id && !filterWorkTypeInCategory().length) ||
            (item.work_type_category.id && !filterWorkTypeInCategory().length)
          "
          height="48px"
          v-model="item.work_type.id"
          :prepend-inner-icon="tableMin ? 'search' : ''"
          :minimize="!tableMin"
          :items="filterWorkTypeInCategory()"
          :rules="['required']"
          :tooltip="
            !item.work_type_category.id
              ? localStorage.translations.pages.sales_project['material_price-tooltips'][
                  'vyberite-kategoriyu-rabot'
                ]
              : localStorage.translations.pages.sales_project['material_price-tooltips'][
                  'k-vybrannoy-kategorii-ne-privyazany-vidy-rabot'
                ]
          "
          :tooltip-disabled="!!item.work_type_category.id && !!filterWorkTypeInCategory().length"
          :view="!edit"
          :view-value="item.work_type.name"
        />
      </div>
    </td>
    <td>
      <div :class="edit ? 'width' : ''">
        <BaseInput
          type="autocomplete"
          :readonly="!workTypeCategoryGridAll.length"
          height="48px"
          v-model="type"
          :prepend-inner-icon="tableMin ? 'search' : ''"
          :minimize="!tableMin"
          :items="typeList"
          :rules="['required']"
          :placeholder="
            localStorage.translations.pages.sales_project['schemes_documents-tables']['ne-vybrano']
          "
          :view="!edit"
          :view-value="findItemData(typeList, type)"
        />
      </div>
    </td>
    <td>
      <div class="size" :class="edit ? 'width' : ''">
        <BaseInput type="switch" v-if="edit" v-model="sizeShow" />
        <BaseInput
          height="48px"
          v-model="item.size"
          :rules="['required']"
          placeholder="10"
          :view="!edit || !sizeShow"
          :view-value="item.size > 0 ? item.size.toLocaleString('fi-FI', {}) : '—'"
          input-type="Number"
        />
      </div>
    </td>
    <td>
      <div :class="edit ? 'width' : ''">
        <BaseInput
          height="48px"
          v-model="measure"
          placeholder="10"
          :view="!edit"
          :view-value="
            item.is_hourly === 0
              ? item.work_type.measure
              : '€/' + localStorage.translations.pages.common.measure.hours_min
          "
          readonly
        />
      </div>
    </td>
    <td v-if="!userSubscriber">
      <div class="size" :class="edit ? 'width' : ''">
        <BaseInput type="switch" v-if="edit" v-model="priceShow" />
        <BaseInput
          height="48px"
          v-model="item.price"
          :rules="['required']"
          placeholder="35"
          :readonly="!item.work_type.id"
          append-outer-icon="euro"
          :view="!edit || !priceShow"
          :view-value="item.price > 0 ? item.price.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2, }) + ' €' : '—'"
          input-type="Number"
        />
      </div>
    </td>
    <td>
      <div class="size" :class="edit ? 'width' : ''">
        <BaseInput type="switch" v-if="edit && item.is_hourly === 1" v-model="hoursShow" />
        <BaseInput
          height="48px"
          v-model="hours"
          :rules="['required']"
          :view="!edit || !hoursShow"
          :view-value="type == 2 && hours > 0 ? hours : '—'"
          input-type="Number"
        />
      </div>
    </td>
    <td v-if="!userSubscriber">
      <div :class="edit ? 'width' : ''">
        <BaseInput
          height="48px"
          v-model="item.salary"
          append-outer-icon="euro"
          placeholder="35"
          :view="!edit"
          :view-value="item.salary ? item.salary.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2, }) + ' €' : '—'"
          input-type="Number"
        />
      </div>
    </td>
    <td v-if="!userSubscriber">
      <div :class="edit ? 'width' : ''">
        <BaseInput
          height="48px"
          v-model="amount"
          readonly
          append-outer-icon="euro"
          placeholder="35"
          :view="!edit || !(item.is_hourly === 0 ? sizeShow && priceShow : hoursShow && priceShow)"
          :view-value="amount ? amount.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2, }) + ' €' : '—'"
          input-type="Number"
        />
      </div>
    </td>
    <td v-if="edit">
      <div class="buttons" v-if="!userSubscriber">
        <DeleteBtn v-if="client" :deleteItem="onDeleteDefaultItem" :deleteItemIndex="itemKey" />
        <DeleteBtn v-if="!client" :deleteItem="onDeleteItem" />
      </div>
    </td>
  </tr>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import DeleteBtn from 'components/DeleteBtn'
import BaseInput from 'components/base/BaseInput'

export default {
  name: 'ProjectMaterialsAndPricesTableItem',
  components: {
    BaseInput,
    DeleteBtn,
  },
  props: ['item', 'itemKey', 'client', 'workTypeList', 'edit', 'tableMin'],
  data: () => ({
    valid: false,
    measure: null,
    workTypeSelect: null,
    workTypeListCategory: [],
    type: null,
    sizeShow: true,
    hoursShow: false,
    hours: null,
    priceShow: true,
    autofocus: '',
    key: 0,
  }),
  updated() {
    if (this.workTypeSelect == undefined) {
      this.workTypeSelect = this.workTypeList.find((i) => i.id === this.item.work_type.id)
    }
  },
  watch: {
    item: {
      handler: function (oldVal, newVal) {
        if (this.edit) {
          this.$emit('editing', {
            key: this.itemKey,
            type: oldVal.project_id ? 'edit' : 'add',
          })
        }
      },
      deep: true,
    },
    sizeShow() {
      if (!this.sizeShow) {
        this.item.size = 0
      } else {
        this.item.size = this.savedItemData && this.savedItemData.size
      }
    },
    hoursShow() {
      if (!this.hoursShow) {
        this.item.hours = 0
      } else {
        this.item.hours = this.savedItemData && this.savedItemData.hours
      }
    },
    priceShow() {
      if (!this.priceShow) {
        this.item.price = 0
      } else {
        this.item.price =
          this.savedItemData &&
          this.savedItemData.price &&
          this.item.work_type.id === this.savedItemData.work_type.id
            ? this.savedItemData.price
            : this.workTypeSelect.price
      }
    },
    type() {
      if (this.type == 1) {
        this.item.is_hourly = 0
      } else if (this.type == 2) {
        this.item.is_hourly = 1
      }
    },
    hours() {
      this.item.hours = this.hours > 0 ? this.hours * 60 : this.hours
    },
    'item.hours'() {
      this.hours = Math.round((this.item.hours / 60) * 100) / 100
    },
    'item.work_type_category.id'() {
      this.item.work_type.id = null
    },
    'item.work_type.id'() {
      if (this.item.work_type.id) {
        this.workTypeSelect = this.workTypeList.find((i) => i.id === this.item.work_type.id)
        if (this.workTypeSelect) {
          this.item.price =
            this.savedItemData &&
            this.savedItemData.price &&
            this.item.work_type.id === this.savedItemData.work_type.id
              ? this.savedItemData.price
              : this.workTypeSelect.price
        }
      }
    },
    'item.is_hourly'() {
      if (this.item.is_hourly == 0) {
        this.measure = this.workTypeSelect && this.workTypeSelect.measure
        this.sizeShow = true
        this.hoursShow = false
      } else {
        this.measure = '€/' + this.localStorage.translations.pages.common.measure.hours_min
        this.item.size = 0
        this.sizeShow = false
        this.hoursShow = true
      }
    },
    workTypeSelect() {
      if (this.workTypeSelect) {
        if (this.item.is_hourly == 0) {
          this.measure = this.workTypeSelect.measure
        } else this.measure = '€/' + this.localStorage.translations.pages.common.measure.hours_min
      }
    },
  },
  mounted() {
    this.onActualData()
    if (this.item.work_type.id && this.workTypeList) {
      this.workTypeSelect = this.workTypeList.find((i) => i.id === this.item.work_type.id)
    }
    if (this.item.is_hourly == 0) {
      this.type = 1
    } else if (this.item.is_hourly == 1) {
      this.type = 2
    }
  },
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('workTypeCategory', ['workTypeCategoryGridAll']),
    ...mapGetters('workClientProjectsWorkType', ['workClientProjectsWorkTypeAll_project']),
    userType() {
      return this.$store.getters['user/userType']
    },
    apiDomain() {
      return this.$store.state.apiDomain
    },
    userSubscriber() {
      return this.userType === 'subscriber'
    },
    typeList() {
      return [
        { id: 1, name: this.localStorage.translations.pages.common.text.transactional },
        { id: 2, name: this.localStorage.translations.pages.common.text.hourly },
      ]
    },
    amount() {
      return this.item.is_hourly == 0
        ? this.item.size ? (this.item.size * this.item.price).toFixed(2) : null
        : this.hours ? (this.hours * this.item.price).toFixed(2) : null
    },
    savedItemData() {
      return this.item.id
        ? this.$navigationGuardianObjectDefault('workClientProjectsWorkTypeAll_project') &&
            this.$navigationGuardianObjectDefault('workClientProjectsWorkTypeAll_project')[
              this.itemKey
            ]
        : null
    },
  },
  methods: {
    ...mapActions('workClientProjectsWorkType', [
      'onWorkClientProjectsWorkTypeDefaultDelete',
      'onWorkClientProjectsWorkTypeDelete',
      'onWorkClientProjectsWorkTypeAll_project',
    ]),
    onActualData() {
      if (this.item.work_type.id && this.workTypeList) {
        this.workTypeSelect = this.workTypeList.find((i) => i.id === this.item.work_type.id)
      }
      if (this.item.is_hourly == 0) {
        this.type = 1
      } else if (this.item.is_hourly == 1) {
        this.type = 2
        if (this.item.hours) {
          this.hoursShow = true
        }
      }
      if (this.item.size == null || this.item.size == 0) {
        this.sizeShow = false
      }
      if (this.item.price == null || this.item.price == 0) {
        this.priceShow = false
      }
      if (this.item.hours == null || this.item.hours == 0) {
        this.hoursShow = false
      } else {
        this.hours = Math.round((this.item.hours / 60) * 100) / 100
      }
    },
    filterWorkTypeInCategory() {
      let wtcId = this.item.work_type_category.id
      return this.workTypeList.filter(function (o) {
        if (o.categories.length) {
          return o.categories.filter((i) => i.id === wtcId).length
        }
      })
    },
    findItemData(array, itemId) {
      if (array.length && itemId) {
        let data = array.find((i) => i.id === itemId)
        return data.name
      } else {
        return '—'
      }
    },
    filterProjectTypeInSegment(segmentId) {
      return (this.projectTypeInSegment = this.workProjectTypeAll.filter(function (o) {
        if (o.segments.length) {
          return o.segments.filter((i) => i.id === segmentId).length
        }
      }))
    },
    onDeleteItem() {
      this.$emit('editing', {
        key: this.itemKey,
        type: 'delete',
      })
    },
    onDeleteDefaultItem(index) {
      this.onWorkClientProjectsWorkTypeDefaultDelete(index)
      this.$emit('editing', {
        key: index,
        type: 'delete',
      })
    },
    onWorkTypeData() {
      this.workTypeSelect = this.workTypeList.filter((i) => i.id === this.item.work_type.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.width {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    min-width: 280px;
  }
}

tr:deep() {
  td {
    .fullSize {
      width: 100%;
      height: 100%;
      display: grid;
      justify-content: center;
      align-items: center;
    }

    .size {
      display: grid;
      grid-template-columns: max-content auto;
      column-gap: 10px;
      align-items: center;
      //margin: -10px 0;
    }
  }
}

tr:not(.tableMin):hover {
  :deep() .minimize {
    .v-input__control {
      .v-input__slot {
        background-color: #f2f2f2 !important;
      }
    }
  }

  :deep() .v-card {
    background-color: #f2f2f2 !important;
  }
}
</style>